export default from './highlighter';



// WEBPACK FOOTER //
// ./app/components/highlighter/index.js